import * as React from 'react'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { JobStatus } from '../types/enums/JobStatus'
import { Fee } from '../types'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

interface DialogBoxProps {
  handleDialogClose: () => void
  handleCancel?: () => void
  jobCanceledByHauler?: () => void
  isDialogOpen: boolean
  status: string
  isCanceledByHauler?: boolean
  fee?: Fee
  isJobReposted?: boolean
  isCanceledByOtherDevice?: boolean
}

interface DialogBoxState {
  isDialogOpen: boolean
  status: string
  isCanceledByHauler: boolean
}

export class DialogBox extends React.Component<DialogBoxProps, DialogBoxState> {
  constructor(props: any) {
    super(props)
    this.state = {
      isDialogOpen: this.props.isDialogOpen,
      status: this.props.status,
      isCanceledByHauler: false
    }
  }

  componentWillReceiveProps(nextProps: any) {
    if (this.props !== nextProps) {
      this.setState({
        isDialogOpen: nextProps.isDialogOpen,
        status: nextProps.status
      })
    }
    if (this.state.status === JobStatus.DECLINED_BY_HAULER || this.state.status === JobStatus.CANCELLED_BY_HAULER ||
      this.state.status === JobStatus.DECLINED_AUTO || this.state.status === 'PAYMENT_ERROR') {

      this.setState({
        isCanceledByHauler: nextProps.isCanceledByHauler
      })
    }
  }

  render() {
    let percent = this.props.fee && this.props.fee.percent
    return (
      <Dialog
        open={this.state.isDialogOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="job-cancel-dialog"
        classes={{ paper: 'job-cancel-dialog-paper' }}
      >
        <DialogTitle id="alert-dialog-title">
          {
            this.state.status === JobStatus.DECLINED_BY_HAULER && !this.props.isJobReposted ? StringResources.getString(Strings.Components.DialogBox.Titles.ProviderPickupCancelled) :
              this.state.status === JobStatus.CANCELLED_BY_HAULER && !this.props.isJobReposted ? StringResources.getString(Strings.Components.DialogBox.Titles.ProviderPickupCancelled) :
                this.state.status === JobStatus.DECLINED_AUTO || this.props.isJobReposted || this.props.isCanceledByOtherDevice ?
                  StringResources.getString(Strings.Components.DialogBox.Titles.PickupCancelled) :
                  this.state.status === 'PAYMENT_ERROR' ? 'Payment error' : StringResources.getString(Strings.Components.DialogBox.Titles.CancelPickup)
          }
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {
              this.state.isCanceledByHauler ? this.props.isJobReposted ? StringResources.getString(Strings.Components.DialogBox.Content.JobRepost) : '' :
                this.state.status === JobStatus.ACCEPTED ||
                  this.state.status === JobStatus.HAULER_ARRIVING ||
                  this.state.status === JobStatus.WAITING_FOR_PAYMENT_AUTHORIZATION ?
                  StringResources.getString(Strings.Components.DialogBox.Content.AreYouSureAssigned, percent)
                  :
                  this.props.isCanceledByOtherDevice ? '' : StringResources.getString(Strings.Components.DialogBox.Content.AreYouSure)
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {
            this.state.isCanceledByHauler || this.props.isCanceledByOtherDevice ? null :
              <Button onClick={this.props.handleDialogClose} color="primary">
                {StringResources.getString(Strings.Components.DialogBox.Buttons.No.label)}
              </Button>
          }
          <Button
            onClick={this.state.isCanceledByHauler || this.props.isCanceledByOtherDevice ? this.props.jobCanceledByHauler : this.props.handleCancel}
            color="primary"
            autoFocus={true}
          >
            {
              this.state.isCanceledByHauler || this.props.isCanceledByOtherDevice ?
                StringResources.getString(Strings.Components.DialogBox.Buttons.Ok.label) :
                StringResources.getString(Strings.Components.DialogBox.Buttons.Yes.label)
            }
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DialogBox.tsx